import { FilterRow } from "@components/FilterTag/FilterTag";
import { Dispatch, SetStateAction, useState } from "react";
import { ThreadQuery } from "../types";
import { TeamTag } from "./TeamTag";
import { StatusTag } from "./StatusTag";
import { RequestTypeTag } from "./RequestTypeTag";
import { StaffAssigneeTag } from "./StaffAssigneeTag";
import { useInstitutionContext } from "@hooks/institutionContext";
import { CustomerTag } from "./CustomerTag";

export function ThreadsFilter({
  filters,
  showStatusTag,
  showTeamTag,
  showStaffAssigneeTag,
  setFilters,
}: {
  filters: ThreadQuery;
  showStatusTag: boolean;
  showTeamTag: boolean;
  showStaffAssigneeTag: boolean;
  setFilters: Dispatch<SetStateAction<ThreadQuery>>;
}) {
  const { institution } = useInstitutionContext();

  const [isSelectorExpanded, setIsSelectorExpanded] = useState(false);
  const [expandedTag, setExpandedTag] = useState<string | null>(null);

  function handleSelect(tag: string) {
    setExpandedTag(tag);
    setIsSelectorExpanded(false);
  }

  return (
    <FilterRow>
      {filters.user.length || expandedTag === "customer" ? (
        <CustomerTag
          filters={filters}
          isExpanded={expandedTag === "customer"}
          close={() => setExpandedTag(null)}
          open={() => setExpandedTag("customer")}
          setFilters={setFilters}
        />
      ) : null}
      {showTeamTag && (filters.assignee.length || expandedTag === "team") ? (
        <TeamTag
          filters={filters}
          expandedTag={expandedTag}
          setExpandedTag={setExpandedTag}
          setFilters={setFilters}
        />
      ) : null}
      {filters.category.length || expandedTag === "category" ? (
        <RequestTypeTag
          filters={filters}
          isExpanded={expandedTag === "category"}
          close={() => setExpandedTag(null)}
          open={() => setExpandedTag("category")}
          setFilters={setFilters}
        />
      ) : null}
      {showStatusTag && (filters.state.length || expandedTag === "state") ? (
        <StatusTag
          filters={filters}
          expandedTag={expandedTag}
          setExpandedTag={setExpandedTag}
          setFilters={setFilters}
        />
      ) : null}
      {showStaffAssigneeTag &&
      (filters.staff_assignee.length || expandedTag === "staff_assignee") ? (
        <StaffAssigneeTag
          filters={filters}
          isExpanded={expandedTag === "staff_assignee"}
          close={() => setExpandedTag(null)}
          open={() => setExpandedTag("staff_assignee")}
          setFilters={setFilters}
        />
      ) : null}
      <FilterRow.Selector
        isExpanded={isSelectorExpanded}
        onUserDismiss={() => setIsSelectorExpanded(false)}
        onToggle={() => setIsSelectorExpanded(!isSelectorExpanded)}
      >
        <FilterRow.Selector.Item
          label={institution.institution_type === "bank" ? "Customer" : "Member"}
          isSelected={!!filters.user.length}
          onSelect={() => {
            handleSelect("customer");
          }}
        />
        {showTeamTag && (
          <FilterRow.Selector.Item
            label="Team"
            isSelected={!!filters.assignee.length}
            onSelect={() => {
              handleSelect("team");
            }}
          />
        )}
        <FilterRow.Selector.Item
          label="Request type"
          isSelected={!!filters.category.length}
          onSelect={() => {
            handleSelect("category");
          }}
        />
        {showStatusTag && (
          <FilterRow.Selector.Item
            label="Status"
            isSelected={!!filters.state.length}
            onSelect={() => {
              handleSelect("state");
            }}
          />
        )}
        {showStaffAssigneeTag && (
          <FilterRow.Selector.Item
            label="Assignee"
            isSelected={!!filters.staff_assignee.length}
            onSelect={() => {
              handleSelect("staff_assignee");
            }}
          />
        )}
      </FilterRow.Selector>
    </FilterRow>
  );
}
